













import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";

@Component({
  components: { VueEditor },
  name: "custom-vue-editor",
})
export default class CustomVueEditorComponent extends Vue {
  @Prop({ default: "" }) label!: String;
  @Prop({ default: 0, type: Number }) id: Number;
  @Prop({ default: "", type: String }) placeholder: String;
  @Prop({ default: false, type: Boolean }) useCustomImageHandler: Boolean;
    @Prop({ default: '' }) value!: string;
  text: String = "";
  innerId: String = "";
  innerValue = this.value;

  @Watch("id")
  idUpdate(newValue: Number) {
    if (newValue) {
      this.innerId = newValue.toString();
    }
  }
  @Watch("innerValue")
  onInnerValueChanged(newValue: string) {
    if (this.innerValue !== this.value) {
      this.$emit("input", this.innerValue);
    }
  }
  @Watch("value")
  onValueChanged(newValue: string) {
    if (this.innerValue !== this.value) {
      this.innerValue = this.value;
    }
  }
  focus() {
  }
}
